export class OrderedTaskProgress {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get orederedTask() {
        return this.parent;
    }
    get isTaskCompleted() {
        return !this.orederedTask.steps.find((step) => !step.stepProgress.isStepCompleted);
    }
    get isTaskFinished() {
        return !this.orederedTask.steps.find((step) => !step.stepProgress.isStepFinished);
    }
}
